import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaskCompletionReportComponent } from './task-completion-report/task-completion-report.component';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-reports',
    imports: [CommonModule, TaskCompletionReportComponent, RouterModule],
    templateUrl: './reports.component.html',
    styleUrl: './reports.component.css'
})
export class ReportsComponent {
  showReport = false;

  showTaskCompletionReport() {
    this.showReport = true;
  }
}
